@if (hasValue) {
	@if (showAsLink(data)) {
		<a class="link-primary" style="cursor: pointer" (click)="linkClicked($event)">{{ value }}</a>
	} @else {
		{{ value }}
	}
}
